/**
 * Flattens a multi-dimensional array
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/Reduce?v=example
 * @param   {Array}  array
 * @return  {Array}
 */
export default function flatten (arr) {
  return arr.reduce((acc, val) => acc.concat(
    Array.isArray(val) ? flatten(val) : val
  ), [])
}



// WEBPACK FOOTER //
// ./src/frontend/util/flatten.js